import React, { useEffect } from "react";
import anime from "animejs/lib/anime.es.js";

const WaterDropGrid = () => {
  return (
    <div className="relative grid w-full h-screen place-content-center bg-black/50 px-8">
      <DotGrid />
    </div>
  );
};

const GRID_WIDTH = 100;
const GRID_HEIGHT = 45;

const DotGrid = () => {
  useEffect(() => {
    function trigger() {
      // First wave
      anime({
        targets: ".dot-point",
        scale: [
          { value: 1.35, easing: "easeOutSine", duration: 250 },
          { value: 1, easing: "easeInOutQuad", duration: 500 },
        ],
        translateY: [
          { value: -15, easing: "easeOutSine", duration: 250 },
          { value: 0, easing: "easeInOutQuad", duration: 500 },
        ],
        opacity: [
          { value: 1, easing: "easeOutSine", duration: 250 },
          { value: 0.5, easing: "easeInOutQuad", duration: 500 },
        ],
        delay: anime.stagger(100, {
          grid: [GRID_WIDTH, GRID_HEIGHT],
          from: "center",
        }),
      });
    }

    trigger(); // run immediately
    const interval = setInterval(trigger, 5000);
    return () => clearInterval(interval);
  }, []);

  const dots = [];
  let index = 0;

  for (let i = 0; i < GRID_WIDTH; i++) {
    for (let j = 0; j < GRID_HEIGHT; j++) {
      dots.push(
        <div
          className="group cursor-crosshair rounded-full p-1 transition-colors hover:bg-slate-600"
          data-index={index}
          key={`${i}-${j}`}
        >
          <div
            className="dot-point h-[5px] w-[5px] rounded-full bg-gradient-to-b from-black to-white/50 opacity-50 group-hover:from-indigo-600 group-hover:to-white"
            data-index={index}
          />
        </div>
      );
      index++;
    }
  }

  return (
    <div
      style={{ gridTemplateColumns: `repeat(${GRID_WIDTH}, 1fr)` }}
      className="grid w-full"
    >
      {dots}
    </div>
  );
};

export default WaterDropGrid;
